app.controller('commentsController', function($http, $scope, $stateParams, $location, dataService, DTColumnBuilder, pageConfig, pageHandler, $timeout, $modal, $anchorScroll, $controller, anchorSmoothScroll, $window) {
	
	//Include custom controller functionality
	$controller('userDefinedCommentsController', {$scope: $scope, $stateParams: $stateParams});

	//initialise survey specific views
	pageHandler.initViews(pageConfig, $scope);

	//initialise filters
	var filtersLoaded = pageHandler.initFilters(pageConfig, $scope);
	
	if(filtersLoaded)
	{	
		//initialise components
		pageHandler.initComponents(pageConfig, $scope);
	
		//show loading on components
		pageHandler.showLoading(pageConfig, $scope);
	
		//request data for components
		pageHandler.requestDataForComponents(pageConfig, $scope);
		
		//initialize export feature
		pageHandler.initPageExports(pageConfig, $scope);
	}    
	//=======page specific methods and processes==========//
	
	//show transcript
	$scope.showTranscript = function(rowData, component, componentKey)
	{
		$('.hide_on_transcript').hide();
		//flag to switch on transcript view
		$scope.transcript = 1;
		$scope.can_access_appeal = false;
		var selectkey = component.config.click_key;
		var selectsurveykey = typeof(component.survey_key != 'undefined') ? component.survey_key : null;

		//add survey id to URL
		$location.hash(rowData[selectkey]);
		
		//Get data for transcript
		$scope[componentKey].selectedRowData = {};
		
		var post_data = {};
		post_data['selectkey'] = selectkey;
		post_data['selectvalue'] = (typeof(rowData[selectkey]) != 'undefined') ? rowData[selectkey] : null;
		post_data['selectsurveyvalue'] = (typeof(selectsurveykey) != 'undefined') ? selectsurveykey : null;
		post_data['app_state'] = $scope.appState;
		
		//add selected survey details to scope for other operations in the page (e.g. hot alert form)
		$scope.pageState= {};
		$scope.pageState.selectkey = post_data['selectkey'];
		$scope.pageState.selectvalue = post_data['selectvalue'];
		$scope.pageState.selectsurveyvalue = post_data['selectsurveyvalue'];

		$scope.rowData = rowData;
		$scope.component = component;
		$scope.componentKey = componentKey;
		//$scope.files = {};

		dataService.getData(component.config.rowclick_url, post_data , 'POST')
			.then(function(response) {
				if(typeof(response.data) != 'undefined')
				{	
					$scope.appeal_doc_download_url = $location.absUrl().split('#')[0]+'/common/document_download';

					if(typeof(response.data.details) != 'undefined')
					{	
						$scope[componentKey].selectedRowData.details = response.data.details;
					}
					if(typeof(response.data.summary) != 'undefined')
					{	
						$scope[componentKey].selectedRowData.summary = response.data.summary;
					}
					if(typeof(response.data.contact_request_details) != 'undefined')
					{	
						if(typeof(response.data.contact_request_details.contact_request.id) != 'undefined') {
							$scope.pageState.contactRequestId = response.data.contact_request_details.contact_request.id;
						}
						if(typeof(response.data.contact_request_details.contact_request.contact_request_status) != 'undefined') {
							$scope.contactRequestStatus = response.data.contact_request_details.contact_request.contact_request_status;
						}
						$scope[componentKey].selectedRowData.contact_request_details = response.data.contact_request_details;
						$scope.contactRequestId = (typeof(response.data.contact_request_details.contact_request.id) != 'undefined') ? response.data.contact_request_details.contact_request.id : null;
						$scope.contactRequestComments = (typeof(response.data.contact_request_details.comments) != 'undefined') ? response.data.contact_request_details.comments : null;
						$scope.contactRequestDetails = (typeof(response.data.contact_request_details.contact_request) != 'undefined') ? response.data.contact_request_details.contact_request : null;
						$scope.contact_request_display = (typeof(response.data.contact_request_display) != 'undefined') ? response.data.contact_request_display : false;
					}
				}
			}
		);
		
	}
	
	//hide transcript
	$scope.hideTranscript = function() {

		//Go to base url, if transcript filter have value
		var submenu_key = $scope['appState']['submenu_key'];
		var filter_transcript_key = 'filter_transcript_' + submenu_key;
		if (typeof $scope[filter_transcript_key] != 'undefined' &&
			typeof $scope[filter_transcript_key]['selected_value'] != 'undefined' &&
			$scope[filter_transcript_key]['selected_value'] !== '') {

			var filter_transcript_return_key = 'filter_transcript_return_' + submenu_key;
			if(typeof $scope[filter_transcript_return_key] != 'undefined' &&
				typeof $scope[filter_transcript_return_key]['selected_value'] != 'undefined' &&
				$scope[filter_transcript_return_key]['selected_value'] !== '') {
				var filter_transcript_return = JSON.parse(window.decodeURI($scope[filter_transcript_return_key]['selected_value']));
				$scope.goToPage(filter_transcript_return.page, {}, filter_transcript_return.submenu_key);
			} else {
				var url = $location.absUrl().split('#')[0];
				$window.location.href = url;
			}
		}

		$('.hide_on_transcript').show();
		//flag to switch on survey view
		$scope.transcript = 0;

		if($('.default_hide').length > 0)
		{
			$('.default_hide').hide();
		}
		if($("#contact_request_submit_form").length > 0)
		{
			$('#contact_request_submit_form')[0].reset();
		}

		$('.panel .panel-heading .fa-chevron-up').toggleClass('fa-chevron-down');
      	$('.panel .panel-heading .fa').removeClass('fa-chevron-up');
		
		//move to the previous scroll psoition
		$timeout(function(){$anchorScroll();}, 300);
	}

	//Open survey transcript, if transcript filter have value
	var submenu_key = $scope['appState']['submenu_key'];
	var filter_transcript_key = 'filter_transcript_' + submenu_key;
	if (typeof $scope[filter_transcript_key] != 'undefined') {
		var filter_transcript = $scope[filter_transcript_key];
		if(typeof filter_transcript['selected_value'] != 'undefined' &&
			filter_transcript['selected_value'] !== '' &&
			typeof filter_transcript['survey_component'] != 'undefined' &&
			typeof filter_transcript['key_metric'] != 'undefined') {

			var selected_value = filter_transcript['selected_value'];
			var metric = filter_transcript['key_metric'];
			var rowData = [];
			rowData[metric] = selected_value;

			var componentKey = filter_transcript['survey_component'];
			if(typeof pageConfig.components[componentKey] != 'undefined' && rowData) {
				var component = pageConfig.components[componentKey];

				if (rowData) {
					$scope.showTranscript(rowData, component, componentKey);
				}
			}
		}
	}
    
});

